<template>
  <v-card elevation="6" class="my-4 mx-4">
        <v-app-bar color="#676767" dense dark>
          <v-toolbar-title>Registro de Informes del Periodo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text to="/perito/show">
              <v-icon>mdi-arrow-left</v-icon>Regresar
            </v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <p class="text-uppercase font-weight-bold mb-0">
                Seleccione el Periodo a Consultar
              </p>
              <v-col cols="12">
                 <v-select
                  label="Periodos"
                  item-text="nombre"
                  item-value="id"
                  :items="listPeriodos_Activo_y_Pasados"
                  v-model="periodoSelected"
                  outlined
                  dense
                  @change="showPeriodoName"
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row justify="space-between" v-if="this.solicitud"> -->
            <v-row justify="space-between" v-if="this.solicitud && habilitado == 1">
              <v-col cols="12" md="6">
                <v-card elevation="7" color="#EEEEEE">
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <v-card-title class="headline"></v-card-title>
                    <v-card-text>
                      <p class="text-uppercase title font-weight-bold mb-0 text-center">
                        {{solicitud.perito_data.nombre}}
                        {{solicitud.perito_data.primer_apellido}}
                        {{solicitud.perito_data.segundo_apellido}}
                      </p>
                      <v-divider></v-divider>
                      <!-- <p class="mb-0">RFC: DIAN830212</p> -->
                      <p class="mb-0 mt-2"><span class="font-weight-medium mb-0">Folio:</span> {{solicitud.perito_data.folio}} </p>
                      <p class="mb-0 mt-0"><span class="font-weight-medium mb-0">E-mail:</span> {{solicitud.perito_data.email_contacto}} </p>
                      <div class="mb-0"><span class="font-weight-medium mb-0">Areas de Especialización:</span><br>
                        <ul v-for="item in solicitud.especialidades_data">
                          <li> {{item.nombre}} </li>
                        </ul>
                      </div>
                      <div class="mb-0"><span class="font-weight-medium mb-0"> Partidos Judiciales:</span><br>
                        <ul v-for="item in solicitud.partidos_judiciales_data">
                          <li> {{item.nombre}} </li>
                        </ul>
                      </div>
                    </v-card-text>
                    <v-avatar
                      class="ma-3 d-none d-sm-flex"
                      size="125"
                      color="white"
                    >
                      <v-icon x-large color="teal">mdi-account-circle</v-icon>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card elevation="7" color="#EEEEEE">
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <v-card-title class="headline"></v-card-title>
                    <v-card-text>
                      <p class="text-uppercase title font-weight-bold mb-0 text-center">
                       Fechas de entrega de informes</p>
                      <v-divider></v-divider>
                      <ul v-if="habilitado == 1" class="mt-3">
                          <li v-for="(entrega, index) in fechasEntregasOrdenadas" :key="'fecha_entrega_'+index">
                            {{entrega.titulo}} ({{entrega.descripcion}}) <br>
                            <b>{{entrega.pivot.fecha_inicial | formatDate}} al {{entrega.pivot.fecha_final | formatDate}}</b><br>
                            <v-btn
                              x-small
                              @click="getInformeCuatrimestre(entrega)"
                            >
                              Consultar
                            </v-btn>
                          </li>
                      </ul>
                      <p v-else class="text-uppercase title font-weight-bold mt-10 text-center">No esta Habilitado para Realizar informes en el periodo seleccionado</p>
                    </v-card-text>
                    <v-avatar
                      class="ma-3 d-none d-sm-flex"
                      size="125"
                      color="white"
                    >
                      <v-icon x-large color="orange">mdi-calendar</v-icon>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="space-between" v-if="!this.solicitud">
              <v-col cols="12" md="12">
              <v-card elevation="7" color="#EEEEEE">
                <div class="d-flex flex-no-wrap justify-space-between">
                  <v-card-title class="headline"></v-card-title>
                  <v-card-text>
                    <p class="text-uppercase title font-weight-bold mb-3 mt-6 text-center">
                      Para registrar un informe, primero ingrese sus datos personales
                      <v-btn depressed to="/perito/show" color="success" v-if="this.periodoActivo.id == this.periodoSelected">
                        Ir a Datos Personales
                      </v-btn>
                    </p>
                  </v-card-text>
                </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="space-between" v-if="this.solicitud && habilitado == 2">
              <v-col cols="12" md="12">
              <v-card elevation="7" color="#EEEEEE">
                <div class="d-flex flex-no-wrap justify-space-between">
                  <v-card-title class="headline"></v-card-title>
                  <v-card-text>
                    <p class="text-uppercase title font-weight-bold mb-3 mt-6 text-center">
                      Para registrar un informe, debe estar habilitado en el periodo
                    </p>
                  </v-card-text>
                </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="scroll-to-me">
                <v-card v-show="cuatrimestreSelected">
                  <v-card-title class="headline">
                    Periodo {{periodoSelectedName}} <br>
                    {{cuatrimestreSelected.titulo}} ({{cuatrimestreSelected.descripcion}})<br>
                    <div v-if="this.informeEntregado" style="display: contents;color: forestgreen;">
                      Informe Entregado
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-toolbar dense flat>
                      <div v-if="isAdmin || peritoHabilitado">
                        <v-btn color="teal" dark @click="mostrarDictamenes()">Registrar Nuevo Dictamen</v-btn>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn v-if="listDictamenes.length>0" color="blue" dark @click="informePdf()">
                        <v-icon>mdi-file-pdf</v-icon>Visualizar Informe
                      </v-btn>
                      <v-btn v-if="messageInactividad" color="blue" dark @click="pdfSinActividad()">
                        <v-icon>mdi-file-pdf</v-icon>Visualizar Informe Sin Actividad
                      </v-btn>
                      <v-btn v-if="informeSinActividad && (isAdmin || peritoHabilitado)" tile dark @click="sinActividad()">
                        <v-icon left>mdi-check</v-icon>REGISTRAR INFORME SIN ACTIVIDAD
                      </v-btn>
                    </v-toolbar>
                    <div v-if="messageInactividad">
                      <v-alert
                        border="right"
                        colored-border
                        type="error"
                        elevation="2"
                      >
                        USTED PRESENTÓ SU INFORME SIN ACTIVIDAD
                      </v-alert>
                    </div>
                    <div v-if="this.listDictamenes">
                      <v-data-table
                        :headers="headers"
                        :items="listDictamenes"
                        :items-per-page="1000"
                        class="elevation-1"
                        no-data-text="NO HAY DICTAMENES POR MOSTRAR"
                        hide-default-footer
                      >
                      <!-- :page.sync="page"
                      :items-per-page="5"
                      @page-count="pageCount = $event" -->
                        <template v-slot:item.especialidad_id="{ item }">
                          <span v-for="(especialidad, key) in listEspecialidad" :key="key">
                              <span v-if="especialidad.id == item.especialidad_id">
                                {{especialidad.nombre}}
                              </span>
                          </span>
                        </template>
                        <!-- <template v-slot:item.partido_id="{ item }">
                          <span v-for="(partido, key) in listPartidos" :key="key">
                              <span v-if="partido.id == item.partido_id">
                                {{partido.nombre}}
                              </span>
                          </span>
                        </template> -->
                        <template v-slot:item.articulo230="{ item }">
                          <span>{{ item.articulo230 == 1 ? 'Si' : 'No' }}</span>
                        </template>
                        <template v-slot:item.honorarios="{ item }">
                          ${{ item.honorarios }}
                        </template>
                        <template v-slot:item.honorarios_cubiertos="{ item }">
                          <span v-if="item.honorarios_cubiertos == 1">
                            Si
                          </span>
                          <span v-else>
                            No
                          </span>
                        </template>
                        <template v-slot:item.fecha_emision="{ item }">
                          {{ item.fecha_emision | formatDate }}
                        </template>
                        <template v-slot:item.action="{ item }" v-if="isAdmin || peritoHabilitado">
                          <v-icon v-if="isAdmin || peritoHabilitado" class="mr-2" @click="editButton(item)" color="orange">
                            mdi-pencil
                          </v-icon>
                          <v-icon v-if="peritoHabilitado" color="red" @click="deleteDictamen(item)">
                            mdi-close
                          </v-icon>
                        </template>
                      </v-data-table>
                      <!-- <div class="text-center pt-2" v-if="listDictamenes.length > itemsPerPage">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                      </div> -->
                      <v-divider></v-divider>
                      <v-card class="mx-3 mt-3" v-if="listDictamenes.length>0 && (isAdmin || peritoHabilitado)">
                        <v-alert outlined type="warning" color="red" prominent border="left">
                          <p class="text-center">
                            <b>Al dar click en el botón "Terminar Informe Cuatrimestral", ya no podrá registrar más dictamenes respecto al cuatrimestre seleccionado</b>
                          </p>
                          <div v-if="isAdmin || peritoHabilitado" class="text-right">
                            <v-btn @click="terminarInforme" depressed color="error">Terminar Informe Cuatrimestral</v-btn>
                          </div>
                        </v-alert>
                      </v-card>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- INICIO FORMULARIO -->
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card>
                <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                  <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click="close">
                        <v-icon>mdi-arrow-left</v-icon>Regresar
                      </v-btn>
                      <v-btn dark text v-if="editedIndex > -1" @click.native="editDictamen()" :loading="loading">
                        <v-icon>mdi-content-save-outline</v-icon>Guardar Cambios
                      </v-btn>
                      <v-btn dark text v-else @click.native="addInforme()" :loading="loading">
                        <v-icon>mdi-content-save-outline</v-icon>Guardar
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card class="mx-3 mt-3">
                    <v-toolbar color="grey" dark dense flat>
                      <h3>{{ formTitle }}</h3>
                    </v-toolbar>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            outlined
                            dense
                            item-text="nombre"
                            item-value="id"
                            :items="listEspecialidad"
                            v-model="editedItem.especialidad_id"
                            label="Especialidad de materia en que versa el peritaje"
                            :rules="notBlankRules"
                            prepend-inner-icon="mdi-reorder-horizontal"
                          ></v-select>

                          <v-autocomplete
                            label="Materia del Juzgado"
                            dense
                            outlined
                            v-model="materia_id"
                            :items="ListMaterias"
                            :rules="notBlankRules"
                            item-text="nombre"
                            item-value="id"
                            prepend-inner-icon="mdi-gavel"
                            no-data-text="No hay Materias"
                          ></v-autocomplete>

                          <v-autocomplete
                            v-if="materia_id && materia_id != 8 && materia_id != 7"
                            outlined
                            dense
                            item-text="nombre"
                            item-value="id"
                            :items="listPartidos"
                            v-model="editedItem.partido_id"
                            label="Partido Judicial"
                            :rules="notBlankRules"
                            prepend-inner-icon="mdi-map-marker-outline"
                            @change="getJuzgadosSelect"
                          ></v-autocomplete>

                          <v-autocomplete
                            v-if="materia_id && materia_id == 7"
                            outlined
                            dense
                            item-text="nombre"
                            item-value="id"
                            :items="listDistritos"
                            v-model="editedItem.distrito_id"
                            label="Distrito"
                            :rules="notBlankRules"
                            prepend-inner-icon="mdi-map-marker-outline"
                            @change="getJuzgadosSelect"
                          ></v-autocomplete>

                          <v-autocomplete
                            v-if="materia_id == 8"
                            outlined
                            dense
                            item-text="nombre"
                            item-value="id"
                            :items="listRegiones"
                            v-model="editedItem.region_id"
                            label="Región Laboral"
                            :rules="notBlankRules"
                            prepend-inner-icon="mdi-map-marker-outline"
                            @change="getJuzgadosSelect"
                          ></v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            item-text="nombre"
                            item-value="id"
                            :items="listJuzgadosByZona"
                            v-model="editedItem.juzgado_id"
                            label="Juzgado"
                            :rules="[v => !!v|| 'Este campo es requerido']"
                            prepend-inner-icon="mdi-bank-outline"
                            :disabled="validateZona"
                          ></v-autocomplete>

                          <v-text-field
                            outlined
                            dense
                            v-model="editedItem.expediente"
                            label="Número de Expediente"
                            :rules="[v => !!v.trim().length || 'Este campo es requerido']"
                            prepend-inner-icon="mdi-pound"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-menu
                            ref="menuDatepicker"
                            v-model="menuDatepicker"
                            :close-on-content-click="false"
                            :return-value.sync="fecha_emision"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                dense
                                v-model="computedDateFormatted"
                                label="Fecha Emisión del Dictamen"
                                hint="YYYY/MM/DD"
                                persistent-hint
                                v-on="on"
                                readonly
                                :rules="notBlankRules"
                                prepend-inner-icon="mdi-calendar"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_emision" :max="new Date().toISOString().substr(0, 10)"  no-title scrollable locale="es-es">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menuDatepicker = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.menuDatepicker.save(fecha_emision)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>

                          <v-checkbox v-model="editedItem.articulo230">
                            <template v-slot:label>
                              <div>
                                De clic aquí si el dictamen se emite en términos del artículo 230 (Gratuito)
                              </div>
                            </template>
                          </v-checkbox>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            v-model="editedItem.honorarios"
                            :label="editedItem.articulo230 ? 'Gastos operativos' : 'Importe de Honorarios'"
                            class="mb-0 pb-0"
                            :rules="[v => editedItem.articulo230 || !!v || 'Este campo es requerido']"
                            prepend-inner-icon="mdi-currency-usd"
                            step="1"
                            @keydown="preventDecimal"
                          ></v-text-field>

                          <v-select
                            :label="editedItem.articulo230 ? 'Gastos operativos cubiertos' : 'Honorarios Cubiertos'"
                            :rules="notBlankRules"
                            :items="itemsHonorariosCubiertos"
                            item-text="text"
                            item-value="id"
                            v-model="editedItem.honorarios_cubiertos"
                            outlined
                            dense
                            prepend-inner-icon="mdi-check"
                          ></v-select>

                        </v-col>
                      </v-row>
                      <v-layout wrap>
                        <v-row>
                          <v-col cols="12">
                            <div class="text-right">
                              <v-btn rounded color="red" dark small @click.native="close()" class="mr-2">Cancelar</v-btn>
                              <v-btn v-if="editedIndex > -1" rounded color="teal" dark small @click.native="editDictamen()" :loading="loading">Guardar Cambios</v-btn>
                              <v-btn v-else rounded color="teal" dark small @click.native="addInforme()" :loading="loading">Registrar Informe</v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- FIN FORMULARIO -->
          </v-container>
        </v-card-text>
      </v-card>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  export default {
    data: () => ({
      // page: 1,
      // pageCount: 0,
      // itemsPerPage: 5,
      filtros:[],
      listDistritos: [],
      listRegiones: [],
      materia_id:'',
      validateZona: true,
      editedIndex: -1,
      editedItem: {
        partido_id:'',
        region_id:'',
        distrito_id:'',
        especialidad_id:'',
        juzgado_id:'',
        expediente:'',
        articulo230: false,
        honorarios:'',
        honorarios_cubiertos:'',
      },
      defaultItem: {
        partido_id:'',
        region_id:'',
        distrito_id:'',
        especialidad_id:'',
        juzgado_id:'',
        expediente:'',
        honorarios:'',
        honorarios_cubiertos:'',
      },
      fecha_emision:'',
      itemsHonorariosCubiertos: [
        { text: 'Si', id: 1 },
        { text: 'No', id: 2 },
      ],
      informe: '',
      loading:false,
      menuDatepicker: false,
      dialog: false,
      valid: true,
      solicitud:{
        perito_data:{},
      },
      listEspecialidad:[],
      // listPartidos:[],
      listJuzgadosByZona:[],
      listDictamenes: [],
      habilitado:'',
      headers: [
          { text: 'Materia', value: 'especialidad_id', align: 'start', sortable: false },
          // { text: 'Partido', value: 'partido_id' },
          { text: 'Zona', value: 'juzgado_data.zona_nombre' },
          { text: 'Juzgado', value: 'juzgado_data.nombre',width: '20%' },
          { text: 'Expediente', value: 'expediente' },
          { text: '230', value: 'articulo230' },
          { text: 'Importe Honorario', value: 'honorarios' },
          { text: 'Honorario Cubierto', value: 'honorarios_cubiertos' },
          { text: 'Fecha emisión', value: 'fecha_emision', width: '10%' },
          { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '10%' }
        ],
      periodoActivo:'',
      periodoSelected:'', //el periodo seleccionado
      periodoSelectedName:'',
      periodoSelectedActivo:'',
       //es el periodo_has_cuatrimestre que corresponde al id al que ir a consultar a la tabla de
       //informes haber si existe este id. Si existe entonces traer los dictamenes correspondientes
       //al iforme_id
      cuatrimestreSelected:'',
      informeId:'',
      informeEntregado: false,
      informeSinActividad: false,
      messageInactividad: false, //Mostrar mensage cuando registran informe sin actividad
      valid:false,
      saveEdited:false,
      isEditing: false,
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }),
    created(){
      this.getPeriodos();
      this.getPartidos();
      this.getRegiones();
      this.getDistritos();
      this.getMaterias();
    },
    computed: {
      ...mapGetters([
        "currentUser", "listPeriodos", "listPartidos", "ListMaterias", "fechasEntregasInformes", "listPeriodos_Activo_y_Pasados"
      ]),
      computedDateFormatted () {
        // return this.formatDate(this.fecha_emision)
        return this.fecha_emision
      },
      fechasEntregasOrdenadas () {
        if (!this.fechasEntregasInformes) return []
        return [...this.fechasEntregasInformes].sort((a, b) => a.id - b.id)
      },
      isAdmin () {
        return this.currentUser.roles && this.currentUser.roles.some(role => role.id <= 2)
      },
      isPerito () {
        return this.currentUser.roles && this.currentUser.roles.some(role => role.id == 3)
      },
      cuatrimestreEnFecha () {
        if (!this.cuatrimestreSelected || !this.cuatrimestreSelected.pivot) return false
        const hoy = new Date().toISOString().substr(0, 10)
        const fechaInicial = this.cuatrimestreSelected.pivot.fecha_inicial.substr(0, 10)
        const fechaFinal = this.cuatrimestreSelected.pivot.fecha_final.substr(0, 10)
        return hoy >= fechaInicial && hoy <= fechaFinal
      },
      peritoHabilitado () {
        return this.isPerito && !this.informeEntregado && this.periodoSelectedActivo == 1 // && this.cuatrimestreEnFecha // Bloqueo por ventana de cuatrimestre deshabilitado para permitir registro mientras el periodo esté activo
      },
      formTitle () {
        return this.editedIndex === -1 ? 'REGISTRAR NUEVO DICTAMEN' : 'EDITAR DICTAMEN'
      },
    },
    watch:{
      periodoSelected(){
        this.cuatrimestreSelected = ''
        this.getFechasEntregas(this.periodoSelected)
        this.showPerito();
      },
      materia_id (val){
        if (this.isEditing) return;
        this.editedItem.juzgado_id = ''
        this.editedItem.partido_id = ''
        this.editedItem.distrito_id = ''
        this.editedItem.region_id = ''
        if(!val){
          this.validateZona = true;
          this.editedItem.juzgado_id = ''
          return this.$refs.form.resetValidation()
        }
      },
      'editedItem.partido_id': function (val) {
        if (this.isEditing) return;
        this.validateZona = false;
        this.editedItem.juzgado_id = '';
        if(!val){
          // this.validateExpediente = false;
          this.validateZona = true;
          this.editedItem.juzgado_id = ''
          return this.$refs.form.resetValidation()
        }
      },
      'editedItem.distrito_id': function (val){
        if (this.isEditing) return;
        this.validateZona = false;
        this.editedItem.juzgado_id = '';
        if(!val){
          // this.validateExpediente = false;
          this.validateZona = true;
          this.editedItem.juzgado_id = ''
          return this.$refs.form.resetValidation()
        }
      },
      'editedItem.region_id': function (val){
        if (this.isEditing) return;
        this.validateZona = false;
        this.editedItem.juzgado_id = '';
        if(!val){
          // this.validateExpediente = false;
          this.validateZona = true;
          this.editedItem.juzgado_id = ''
          return this.$refs.form.resetValidation()
        }
        console.log('validateZona', this.validateZona);
      },
      'editedItem.articulo230': {
        immediate: true, // Se ejecuta al montar el componente
        handler(newValue) {
          if (this.isEditing) return;
          if (newValue) {
            this.editedItem.honorarios = 0; 
            //this.editedItem.honorarios_cubiertos = 1;
          }
        }
      }
    },
    filters: {
      formatDate (date) {
        if (!date) return null
        let cutDate = date.substr(0, 10)
        const [year, month, day] = cutDate.split('-')
        return `${day}-${month}-${year}`
      },
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      preventDecimal(e) {
        if (['.', ',', 'e', 'E', '+'].includes(e.key)) {
          e.preventDefault();
        }
      },
      getMaterias() {
        this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => { 
        }).catch(error => {
          console.log(error);
        });
      },
      getPartidos() {
        this.$store.dispatch("GET_PARTIDOS",  { url: "partidos-judiciales" } ).then(response => {
          })
          .catch(err => {
            console.log(err);
          });
      },
      getRegiones() {
        this.$store.dispatch("GET_REGIONES",  { url: "/regiones" } ).then(response => {
          this.listRegiones = response.data.data.regiones
          })
          .catch(err => {
            console.log(err);
          });
      },
      getDistritos() {
        this.$store.dispatch("GET_DISTRITOS",  { url: "/distritos" } ).then(response => {
          this.listDistritos = response.data.data.distritos
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPeriodos() {
        this.$store.dispatch("GET_PERIODOS",  { url: "periodos" } ).then(response => {
          let userData =  JSON.parse(localStorage.getItem("user"))
          this.periodoSelected = userData.periodo_id;
          this.peritoSelected_id = userData.perito_id;
          this.listPeriodos.forEach(element => {
            if (element.activo == 1) {
              this.periodoActivo = element
            }
          });
          this.showPeriodoName()
        })
        .catch(err => {
          console.log(err);
        });
      },
      showPeriodoName(){
        this.listPeriodos.forEach(element => {
          if (element.id == this.periodoSelected) {
            this.periodoSelectedName = element.nombre
            this.periodoSelectedActivo = element.activo
          }
        });
      },
      getFechasEntregas(periodoId) {
        this.$store.dispatch("GET_FECHAS_ENTREGAS_INFORMES",  { url: "/periodo/" + periodoId + "/cuatrimestres" } ).then(response => {
        })
        .catch(err => {
          console.log(err);
        });
      },
      getInformeCuatrimestre(periodo_has_cuatrimestre){
        this.cuatrimestreSelected = periodo_has_cuatrimestre;
        this.listDictamenes = [];
        this.informeEntregado = false;
        this.informeSinActividad = false;
        this.messageInactividad = false;
        this.informeId = null;
        this.$store.dispatch("GET_DICTAMENES",{ url: "/dictamenes/" + this.peritoSelected_id  + "/" + this.cuatrimestreSelected.pivot.id}).then((response) => {
          this.informeSinActividad = false;
          this.messageInactividad = false
          //Si no hay informe para el cuatrimestre seleccionado
          if (response.data.data.informe == null) {
            this.informeSinActividad = true;
            this.messageInactividad = false
          }
          //Si el informe ya se entregó sin registrar actividad
          if (response.data.data.informe && response.data.data.informe.sin_actividad == 1 ) {
            this.informeSinActividad = false;
            this.messageInactividad = true
          }

          //si existe informe y aun no lo entregan
          if (response.data.data.informe &&
            response.data.data.informe.sin_actividad == null &&
            response.data.data.informe.fecha_entrega == null)
            {
              if (response.data.data.dictamenes.length > 0) {
                this.informeSinActividad = false;
                this.messageInactividad = false
              }else {
                console.log("Aqui estas con dictamenes borrados y sin entregar inform")
                //aqui existe el informe pero borraron los diactemenes
                this.informeSinActividad = true;
                //this.messageInactividad = true
              }
            }

          this.listDictamenes =  response.data.data.dictamenes;
          if (response.data.data.informe) {
            this.informeId = response.data.data.informe.id
            if (response.data.data.informe.fecha_entrega) {
              this.informeEntregado = true
            }else {
              this.informeEntregado = false;
            }
          }else {
            this.informeId = null
            this.informeEntregado = false;
          }
          // console.log('GET_DICTAMENES',response);
          const el = this.$el.getElementsByClassName('scroll-to-me')[0];
          el.scrollIntoView({ behavior: 'smooth' })
          this.dialog = false;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
      },
      showPerito() {
        this.$store.dispatch("SHOW_PERITO",{ url: "/documentos/" + this.peritoSelected_id + "/solicitudes/" + this.periodoSelected}).then((response) => {
          if (response.data.data.solicitud) {
            // console.log(response.data.data.solicitud);
            this.habilitado = response.data.data.solicitud.habilitado
            this.listEspecialidad = response.data.data.solicitud.especialidades_data
            // this.listPartidos = response.data.data.solicitud.partidos_judiciales_data
          }
          this.solicitud =  response.data.data.solicitud;
        })
        .catch(err => {
          console.log(err);
        });
      },

      getJuzgadosSelect() {
        let zona_id = this.editedItem.partido_id || this.editedItem.region_id || this.editedItem.distrito_id;
        this.filtros = {
          materia_id: this.materia_id,
          zona_id: zona_id,
        }
        this.editedItem.juzgado_id = ''
        this.validateZona = false
        this.$store.dispatch("GET_JUZGADOS_SELECT",  { url: "/juzgados/list-select", data:this.filtros } ).then(response => {
          this.listJuzgadosByZona = response.data.data.juzgados
        })
        .catch(err => {
          console.log(err);
        });
      },
      getJuzgadosByPartido() {
        this.editedItem.juzgado_id = ''
        this.validateZona = false
        this.$store.dispatch("GET_JUZGADOS_BY_PARTIDO",  { url: "/partido-judicial/" + this.editedItem.partido_id + "/juzgados" } ).then(response => {
          this.listJuzgadosByZona = response.data.data.juzgados
        })
        .catch(err => {
          console.log(err);
        });
      },
      getJuzgadosByRegion() {
        this.editedItem.juzgado_id = ''
        this.validateZona = false
        this.$store.dispatch("GET_JUZGADOS_BY_ZONA",  { url: "/region/" + this.editedItem.region_id + "/juzgados" } ).then(response => {
          this.listJuzgadosByZona = response.data.data.juzgados
        })
        .catch(err => {
          console.log(err);
        });
      },
      getJuzgadosByDistrito() {
        this.editedItem.juzgado_id = ''
        this.validateZona = false
        this.$store.dispatch("GET_JUZGADOS_BY_ZONA",  { url: "/distrito/" + this.editedItem.distrito_id + "/juzgados" } ).then(response => {
          this.listJuzgadosByZona = response.data.data.juzgados
        })
        .catch(err => {
          console.log(err);
        });
      },
      mostrarDictamenes(){
        this.dialog = true
      },
      informePdf(){
        this.$store.dispatch("GET_PDF",  { url: "/informe/" + this.informeId + "/pdf" } ).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.overlay = false
        })
        .catch(err => {
          console.log(err);
        });
      },
      addInforme(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.informe = {
            user_id: this.peritoSelected_id,
            periodo_has_cuatrimestres_id: this.cuatrimestreSelected.pivot.id,
            partido_id: this.editedItem.partido_id,
            distrito_id: this.editedItem.distrito_id,
            region_id: this.editedItem.region_id,
            especialidad_id: this.editedItem.especialidad_id,
            juzgado_id: this.editedItem.juzgado_id,
            expediente: this.editedItem.expediente,
            articulo230: this.editedItem.articulo230 ? 1 : 0,
            honorarios: this.editedItem.honorarios,
            honorarios_cubiertos: this.editedItem.honorarios_cubiertos,
            fecha_emision: this.fecha_emision,
          };
          this.$store.dispatch("SAVE_DICTAMEN",{ url: "/dictamen/create", data:this.informe }).then((response) => {
            this.getInformeCuatrimestre(this.cuatrimestreSelected);
            this.close();
            Swal.fire({
              icon: 'success',
              title: 'Dictamen Agregado Correctamente.',
              confirmButtonText: "Aceptar"
            })
          })
          .catch(err => {
            console.log(err);
          });
        }
      },
      sinActividad(){
        this.$swal({
          title: '¿Estas Seguro en Terminar Informe Cuatrimestral Sin Actividad?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.value) {
            this.informe = {
              sin_actividad: 1,
              user_id: this.peritoSelected_id,
              periodo_has_cuatrimestres_id: this.cuatrimestreSelected.pivot.id,
            };
            this.$store.dispatch("SAVE_DICTAMEN",{ url: "/dictamen/create", data:this.informe }).then((response) => {
              // this.pdfSinActividad(response.data.data.informe.id);
              this.getInformeCuatrimestre(this.cuatrimestreSelected);
            })
            .catch(err => {
              console.log(err);
            });
          }
        })
      },
      pdfSinActividad(){
        this.$store.dispatch("GET_PDF",  { url: "/informe/sin-actividad/" + this.informeId + "/pdf" } ).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.overlay = false
        })
        .catch(err => {
          console.log(err);
        });
      },
      terminarInforme(){
        this.$swal({
          title: '¿Está seguro en Terminar Informe Cuatrimestral?',
          text: 'Si tiene aclaraciones respecto del informe, regístrelas en el siguiente apartado',
          icon: 'question',
          input: "textarea",
          inputPlaceholder: "Aclaraciones",
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.isConfirmed) {
            console.log(result.value);
            const aclaraciones = result.value || ''; 
            this.$store.dispatch("TERMINAR_INFORME", { 
              url: "/informe/" + this.informeId,
              data: {
                aclaraciones,
              }
            }).then(res => {
              Swal.fire({
                icon: 'success',
                title: 'Informe Terminado Correctamente.',
                confirmButtonText: "Aceptar"
              })
              this.getInformeCuatrimestre(this.cuatrimestreSelected);
            })
            .catch(err => {
              console.log(err);
            });
          }
        })
      },
      editButton(item){
        this.isEditing = true;
        this.editedIndex = this.listDictamenes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.articulo230 = item.articulo230 == 1 ? true : false;
        this.fecha_emision = item.fecha_emision.substring(0, 10);
        this.validateZona = false;
        this.listJuzgadosByZona = [];

        // Extraer materia y zona del juzgado_data ya que el dictamen no guarda esos campos
        const juzgado = item.juzgado_data;
        this.materia_id = juzgado.materia_id;

        // Limpiar campos de zona para asignar solo el que corresponde según la materia
        this.editedItem.partido_id = '';
        this.editedItem.distrito_id = '';
        this.editedItem.region_id = '';

        // Determinar zona basándonos en la materia (misma lógica que el template)
        // materia 7 = Distrito, materia 8 = Región, cualquier otra = Partido Judicial
        let dispatchAction = '';
        let dispatchUrl = '';

        if (this.materia_id == 7) {
          this.editedItem.distrito_id = juzgado.distrito_id;
          dispatchAction = 'GET_JUZGADOS_BY_ZONA';
          dispatchUrl = '/distrito/' + juzgado.distrito_id + '/juzgados';
        } else if (this.materia_id == 8) {
          this.editedItem.region_id = juzgado.region_id;
          dispatchAction = 'GET_JUZGADOS_BY_ZONA';
          dispatchUrl = '/region/' + juzgado.region_id + '/juzgados';
        } else {
          this.editedItem.partido_id = juzgado.partido_judicial_id;
          dispatchAction = 'GET_JUZGADOS_BY_PARTIDO';
          dispatchUrl = '/partido-judicial/' + juzgado.partido_judicial_id + '/juzgados';
        }

        this.dialog = true;

        // Cargar los juzgados de la zona correspondiente y luego reasignar juzgado_id
        this.$nextTick(() => {
          this.$store.dispatch(dispatchAction, { url: dispatchUrl }).then(response => {
            this.listJuzgadosByZona = response.data.data.juzgados;
            this.editedItem.juzgado_id = item.juzgado_id;
            this.$nextTick(() => { this.isEditing = false; });
          }).catch(err => {
            this.isEditing = false;
            console.log(err);
          });
        });
      },
      deleteDictamen(item){
        this.$swal({
          title: '¿Desea eliminar el Dictamen del expediente ' + item.expediente + '?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("DELETE_DICTAMEN", { url: "/dictamen/" + item.id } ).then(res => {
              Swal.fire({
                icon: 'success',
                title: 'Dictamen eliminado correctamente.',
                confirmButtonText: "Aceptar"
              })
              this.getInformeCuatrimestre(this.cuatrimestreSelected);
            })
            .catch(err => {
              console.log(err);
            });
          }
        })
      },
      editDictamen(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.informe = {
            user_id: this.peritoSelected_id,
            periodo_has_cuatrimestres_id: this.cuatrimestreSelected.pivot.id,
            partido_id: this.editedItem.partido_id,
            distrito_id: this.editedItem.distrito_id,
            region_id: this.editedItem.region_id,
            especialidad_id: this.editedItem.especialidad_id,
            juzgado_id: this.editedItem.juzgado_id,
            expediente: this.editedItem.expediente,
            articulo230: this.editedItem.articulo230 ? 1 : 0,
            honorarios: this.editedItem.honorarios,
            honorarios_cubiertos: this.editedItem.honorarios_cubiertos,
            fecha_emision: this.fecha_emision,
          };
          this.$store.dispatch("UPDATE_DICTAMEN",{ url: "/dictamen/" + this.editedItem.id , data:this.informe }).then((response) => {
            Swal.fire({
              icon: 'success',
              title: 'Dictamen actualizado.',
              confirmButtonText: "Aceptar"
            })
            this.getInformeCuatrimestre(this.cuatrimestreSelected);
            this.close();
          })
          .catch(err => {
            console.log(err);
          });
        }
      },

      close () {
        this.dialog = false;
        this.fecha_emision = ''
        this.materia_id = ''
        this.isEditing = false;
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$refs.form.resetValidation()
        this.editedIndex = -1
      },
    }
};
</script>
